import * as React from "react";

const IconLargeArrowLeft: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="40" viewBox="0 0 24 40" fill="currentColor"><polygon fill="currentColor" points="24 20 0 40 0 0" transform="matrix(-1 0 0 1 24 0)"/></svg>;
};

export default React.memo(IconLargeArrowLeft);
